import { Divider } from "@/components/atoms/Divider";
import { cn } from "@/lib/utils";

export type PriceSummarySkeletonRowProps = {
  rowIndex?: number;
  isTotalRow?: boolean;
};
const PriceSummarySkeletonRow = ({
  rowIndex,
  isTotalRow,
}: PriceSummarySkeletonRowProps) => {
  // Determine which set of widths to apply based on the rowIndex % 3
  const rowPattern = rowIndex && rowIndex % 3;
  return (
    <div className="tw-flex tw-gap-32 tw-justify-between">
      <div
        className={cn(
          "tw-h-16 tw-bg-gray-200 tw-animate-pulse tw-flex-initial",
          {
            "tw-w-[68%] tw-max-w-[140px]": rowPattern === 0,
            "tw-w-[62%] tw-max-w-[106px]": rowPattern === 1,
            "tw-w-[64%] tw-max-w-[128px]": rowPattern === 2,
            "tw-w-[58%] tw-max-w-[71px]": isTotalRow,
          },
        )}
      />
      <div
        className={cn(
          "tw-h-16 tw-bg-gray-200 tw-animate-pulse tw-flex-initial",
          {
            "tw-w-[32%] tw-max-w-[85px]": rowPattern === 0,
            "tw-w-[38%] tw-max-w-[50px]": rowPattern === 1,
            "tw-w-[36%] tw-max-w-[71px]": rowPattern === 2,
            "tw-w-[42%] tw-max-w-[50px]": isTotalRow,
          },
        )}
      />
    </div>
  );
};

export type PriceSummarySkeletonProps = {
  totalRows?: number;
};
export const PriceSummarySkeleton = ({
  totalRows = 3,
}: PriceSummarySkeletonProps) => (
  <div className="tw-space-y-16 tw-w-full">
    {[...Array(totalRows)].map((_, i) => (
      <PriceSummarySkeletonRow
        key={`price-summary-skeleton-${i}`}
        rowIndex={i}
      />
    ))}

    <Divider />

    <PriceSummarySkeletonRow isTotalRow={true} />
  </div>
);
